import React from 'react';
import { useSelector } from 'react-redux';

import { ThemeProvider } from '@material-ui/core/styles';
import { CssBaseline, StyledEngineProvider } from '@material-ui/core';
import { Toaster } from 'react-hot-toast';

// routing
import Routes from './routes';

// defaultTheme
import theme from './themes';

import EmailListener from './utils/emailListener';

// project imports
import NavigationScroll from './layout/NavigationScroll';

// Polls asset-manifest.json (rewritten on every CRA build) and reloads when the hashed
// main bundle path changes, so a deploy reaches open tabs without manual Cmd+Shift+R.
const useAutoReloadOnDeploy = () => {
    React.useEffect(() => {
        let initialMain = null;
        let stopped = false;
        const check = async () => {
            try {
                const r = await fetch(`/asset-manifest.json?t=${Date.now()}`, { cache: 'no-store' });
                if (!r.ok) return;
                const m = await r.json();
                const main = (m && m.files && m.files['main.js']) || null;
                if (!main || stopped) return;
                if (initialMain === null) initialMain = main;
                else if (initialMain !== main) window.location.reload();
            } catch (e) {
                // network blip — just try again next tick
            }
        };
        check();
        const id = setInterval(check, 60000);
        return () => {
            stopped = true;
            clearInterval(id);
        };
    }, []);
};

//-----------------------|| APP ||-----------------------//

const App = () => {
    const customization = useSelector((state) => state.customization);
    useAutoReloadOnDeploy();

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme(customization)}>
                <CssBaseline />
                <NavigationScroll>
                    <Routes />
                </NavigationScroll>
            </ThemeProvider>
            <Toaster toastOptions={{
                className: '',
                style: {
                    display: 'flex',
                    maxWidth: '60%'
                },
            }} />
            <EmailListener />
        </StyledEngineProvider>
    );
};

export default App;
